/* Review draft. Does not touch cart, price, variants or Chatwill's iframe. */
(() => {
  const root = document.documentElement;
  if (root.hasAttribute('data-modii-utilities-mounted')) return;
  root.setAttribute('data-modii-utilities-mounted', '');
  const mobile = matchMedia('(max-width: 767px)');
  let pending = false;
  const transitions = new Map();
  const observed = new Set();
  const visible = element => {
    if (!element) return false;
    const style = getComputedStyle(element);
    const box = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      Number(style.opacity) > 0 && box.width > 0 && box.height > 0;
  };
  const set = (key, value) => {
    if (root.style.getPropertyValue(key) !== value) root.style.setProperty(key, value);
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  function update() {
    pending = false;
    for (const [element, deadline] of transitions) {
      if (!element.isConnected || performance.now() > deadline) transitions.delete(element);
    }
    if (transitions.size) schedule();
    const bars = [...document.querySelectorAll('.m-sticky-addtocart')];
    const launcher = document.querySelector('#willlink-app .willlink-btn-container');
    for (const element of [...bars, launcher].filter(Boolean)) {
      if (!observed.has(element)) { resize.observe(element); observed.add(element); }
    }
    for (const element of observed) {
      if (!element.isConnected) { resize.unobserve(element); observed.delete(element); }
    }
    const bar = mobile.matches && bars.find(element => {
      const box = element.getBoundingClientRect();
      return visible(element) && (box.top < innerHeight - 1 || transitions.has(element)) && box.bottom > 0 &&
        getComputedStyle(element).position === 'fixed';
    });
    if (!bar) {
      root.removeAttribute('data-modii-mobile-atc');
      return; // Original theme/app positions take over without inline overrides.
    }
    const box = bar.getBoundingClientRect();
    set('--modii-atc-height', `${Math.ceil(box.height)}px`);
    set('--modii-atc-clearance', `${Math.ceil(Math.max(box.height, innerHeight - box.top))}px`);
    const chatHeight = visible(launcher) ? Math.ceil(launcher.getBoundingClientRect().height) : 0;
    set('--modii-chat-height', `${chatHeight}px`);
    set('--modii-chat-gap', chatHeight ? '12px' : '0px');
    root.setAttribute('data-modii-mobile-atc', '');
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('transitionrun', event => {
    if (event.target.matches?.('.m-sticky-addtocart') && event.propertyName === 'transform') {
      transitions.set(event.target, performance.now() + 2000);
      schedule();
    }
  }, true);
  for (const eventName of ['transitionend', 'transitioncancel']) {
    document.addEventListener(eventName, event => {
      if (event.propertyName === 'transform') transitions.delete(event.target);
      schedule();
    }, true);
  }
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
  });
  schedule();
})();
